import { styled } from '../../../styles'
import { BaseThemeType } from '../../../theme'
import { CheckoutFinancingPricingParams } from '../types'
import FinanceMarketplaceFinancingCard from './FinanceMarketplaceFinancingCard'
import FinanceMarketplaceSystemSummary from './FinanceMarketplaceSystemSummary'

type PropTypes = {
  pricingParams: CheckoutFinancingPricingParams
  updatePricingParams: (newParams: CheckoutFinancingPricingParams) => void
}

const Wrapper = styled('div')(({ theme }: { theme: BaseThemeType }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  width: '100%',
}))

const FinanceMarketplaceSummary = (props: PropTypes) => {
  const { pricingParams, updatePricingParams } = props
  return (
    <Wrapper>
      <FinanceMarketplaceSystemSummary />
      <FinanceMarketplaceFinancingCard pricingParams={pricingParams} updatePricingParams={updatePricingParams} />
    </Wrapper>
  )
}

export default FinanceMarketplaceSummary
